import { useState } from 'react';

import type { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';

import styles from './CreditCardNumber.module.css';

import type { StyledCreditCardInputProps } from '../StyledStripeInput/StyledStripeInput';
import { StyledStripeInput } from '../StyledStripeInput/StyledStripeInput';

/** The possible brand string values as defined by stripe-js. */
export type CreditCardBrand = StripeCardNumberElementChangeEvent['brand'];

export type CreditCardNumberProps = Omit<
  StyledCreditCardInputProps<'cardNumber'>,
  'type'
> & {
  brand?: CreditCardBrand;
};

/**
 * Render a Credit Card Expiry input. Must be child of {@link StripeProvider} and
 * {@link StripeElementsProvider}.
 */
export function CreditCardNumber(props: CreditCardNumberProps) {
  const [stripeBrand, setStripeBrand] = useState<CreditCardBrand>();

  const handleChange: StyledCreditCardInputProps<'cardNumber'>['onChange'] = (
    event,
    element
  ) => {
    setStripeBrand(event.brand);
    props.onChange?.(event, element);
  };

  const brand = props.brand || stripeBrand || 'unknown';

  return (
    <StyledStripeInput
      type="cardNumber"
      {...props}
      onChange={handleChange}
      inputClassName={props.inputClassName}
      className={styles.container}
    >
      {brand && brand !== 'unknown' && (
        <div className={styles.logoContainer}>
          <img alt={`${brand} logo`} width="32" className={styles[brand]} />
        </div>
      )}
    </StyledStripeInput>
  );
}
